module.exports = __webpack_public_path__ + "Roboto-BlackItalic.ad0f284c7113fd0aaf39.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BlackItalic.ttf
// module chunks = 5